"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8392],{

/***/ 77479:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ MainBlock; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var aphrodite__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34397);
/* harmony import */ var _MainBlockStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36745);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);


var _excluded = ["styles", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var MainBlock = function MainBlock(props) {
  var styles = props.styles,
      children = props.children,
      rest = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, _excluded);

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", _objectSpread(_objectSpread({
    className: (0,aphrodite__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_MainBlockStyle__WEBPACK_IMPORTED_MODULE_3__/* .MainBlockStyle.block */ .d.block, styles)
  }, rest), {}, {
    children: children
  }));
};

/***/ }),

/***/ 36745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ MainBlockStyle; }
/* harmony export */ });
/* harmony import */ var aphrodite__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34397);

var MainBlockStyle = aphrodite__WEBPACK_IMPORTED_MODULE_0__/* .StyleSheet.create */ .mM.create({
  block: {
    boxSizing: "border-box"
  }
});

/***/ }),

/***/ 59941:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* reexport safe */ _MainBlock__WEBPACK_IMPORTED_MODULE_1__.R; }
/* harmony export */ });
/* harmony import */ var _MainBlockStyle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36745);
/* harmony import */ var _MainBlock__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77479);



/***/ }),

/***/ 60206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ FixedConsultationButtonBlock; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(70917);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14416);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96749);
/* harmony import */ var main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80910);
/* harmony import */ var main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36716);
/* harmony import */ var main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25968);
/* harmony import */ var main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(88433);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(26793);
/* harmony import */ var main_javascripts_hooks_common_useScroll__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(17844);
/* harmony import */ var main_javascripts_utils_trackingUtil__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(18531);
/* harmony import */ var main_javascripts_constants_GoogleTagManagerEventTypes__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(12327);
/* harmony import */ var _icon_SvgIcon__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(51752);
/* harmony import */ var main_javascripts_utils_DeviceUtil__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(61838);
/* harmony import */ var main_javascripts_store__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(79169);
/* harmony import */ var main_javascripts_slices_paramSlice__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(9195);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(35944);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

/* eslint-disable react/jsx-no-target-blank */



















var iconLinePath = "".concat(main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_7__/* .PATH_SCOPE */ .j1, "/main/images/icons/line.svg");
var FixedConsultationButtonBlock = function FixedConsultationButtonBlock() {
  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_15__/* .useTranslation */ .$)(["component", "button"]),
      t = _useTranslation.t;

  var isTrackingParameterStored = (0,main_javascripts_store__WEBPACK_IMPORTED_MODULE_13__/* .useAppSelector */ .CG)(main_javascripts_slices_paramSlice__WEBPACK_IMPORTED_MODULE_14__/* .isTrackingParameterStoredSelector */ .gv); // TODO: 旧reducer

  var breakpoint = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function (state) {
    return state.breakpointReducer.breakpoint;
  });
  var isPhoneWidthRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)((0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_8__/* .isPhone */ .Mn)(breakpoint));
  isPhoneWidthRef.current = (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_8__/* .isPhone */ .Mn)(breakpoint);
  var emailConsultationBasePath = "/mail_cruise_consultations/new";

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      showLineButton = _useState[0],
      setShowLineButton = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_7__/* .LINE_ENTRY_LIFF_URL */ .SZ),
      lineEntryUrl = _useState2[0],
      setLineEntryUrl = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(emailConsultationBasePath),
      emailConsultationPath = _useState3[0],
      setEmailConsultationPath = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(isPhoneWidthRef.current),
      hideButton = _useState4[0],
      setHideButton = _useState4[1];

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    setShowLineButton((0,main_javascripts_utils_DeviceUtil__WEBPACK_IMPORTED_MODULE_16__/* .isMobile */ .tq)());
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (isTrackingParameterStored) {
      var params = (0,main_javascripts_utils_trackingUtil__WEBPACK_IMPORTED_MODULE_10__/* .getLineEntryValues */ .M)();

      var newParams = _objectSpread(_objectSpread({}, params), {}, {
        cruise: true
      });

      var queryString = (0,qs__WEBPACK_IMPORTED_MODULE_3__.stringify)(newParams, {
        addQueryPrefix: true
      });
      setLineEntryUrl("".concat(main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_7__/* .LINE_ENTRY_LIFF_URL */ .SZ).concat(queryString));
      setEmailConsultationPath("".concat(emailConsultationBasePath).concat(queryString));
    }
  }, [isTrackingParameterStored]);
  (0,main_javascripts_hooks_common_useScroll__WEBPACK_IMPORTED_MODULE_9__/* .useScroll */ .v)(function (currentScrollY) {
    if (!isPhoneWidthRef.current) {
      setHideButton(false);
      return;
    }

    if (currentScrollY > 100) {
      setHideButton(false);
    } else {
      setHideButton(true);
    }
  });
  var blockStyles = hideButton ? [blockStyle, hiddenStyle] : blockStyle;
  var emailButtonTextStyles = showLineButton ? textStyle : textLargeStyle;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsxs */ .BX)("div", {
    css: blockStyles,
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsxs */ .BX)("a", {
      css: buttonStyle,
      href: emailConsultationPath,
      "data-event-category": main_javascripts_constants_GoogleTagManagerEventTypes__WEBPACK_IMPORTED_MODULE_11__/* .GoogleTagManagerEventTypes.clickCruiseConsultation */ .T.clickCruiseConsultation,
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsxs */ .BX)("div", {
        css: innerEmailStyle,
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)("div", {
          css: symbolStyle,
          children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_icon_SvgIcon__WEBPACK_IMPORTED_MODULE_12__/* .SvgIcon */ .l, {
            name: "email",
            size: "32px"
          })
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)("div", {
          css: emailButtonTextStyles,
          children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)("span", {
            css: lineFooterTextStyle,
            children: t("button:consultation.consultViaPlatformShort", {
              platform: t("constant:platformType.email")
            })
          })
        })]
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)("div", {
        css: badgeStyle,
        children: t("post.free")
      })]
    }), showLineButton && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsxs */ .BX)("a", {
      css: buttonStyle,
      href: lineEntryUrl,
      "data-event-category": main_javascripts_constants_GoogleTagManagerEventTypes__WEBPACK_IMPORTED_MODULE_11__/* .GoogleTagManagerEventTypes.clickCruiseConsultation */ .T.clickCruiseConsultation,
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsxs */ .BX)("div", {
        css: innerLineStyle,
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)("div", {
          css: symbolStyle,
          children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)("img", {
            src: iconLinePath,
            alt: "LINE"
          })
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)("div", {
          css: textStyle,
          children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)("span", {
            css: lineFooterTextStyle,
            children: t("button:consultation.consultViaPlatformShort", {
              platform: t("constant:platformType.line")
            })
          })
        })]
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)("div", {
        css: badgeStyle,
        children: t("post.free")
      })]
    })]
  });
};
var blockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__.css)("position:fixed;bottom:0;right:0;width:100%;display:flex;gap:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__/* .space.atom */ .D.atom, ";margin:0 auto;padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__/* .space.atom */ .D.atom, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__/* .space.atom */ .D.atom, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__/* .space.atom1_5x */ .D.atom1_5x, ";background-color:rgba(255, 255, 255, 0.3);backdrop-filter:blur(40px) saturate(1.2);box-sizing:border-box;z-index:1;transition:opacity 0.6s ease,visibility 0.6s ease;", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_8__/* .moreThanBreakpoint */ .h6)("tablet"), "{bottom:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__/* .space.atom2x */ .D.atom2x, ";right:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__/* .space.atom2x */ .D.atom2x, ";width:fit-content;background:0;backdrop-filter:none;gap:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__/* .space.atom3x */ .D.atom3x, ";}", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_8__/* .moreThanBreakpoint */ .h6)("desktop"), "{bottom:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__/* .space.atom3x */ .D.atom3x, ";right:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__/* .space.atom3x */ .D.atom3x, ";}" + ( true ? "" : 0),  true ? "" : 0);
var hiddenStyle =  true ? {
  name: "8792bh",
  styles: "opacity:0;visibility:hidden"
} : 0;
var buttonStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__.css)("display:flex;width:100%;max-width:18rem;min-height:2.75rem;text-decoration:none;margin:0 auto;position:relative;", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_8__/* .moreThanBreakpoint */ .h6)("tablet"), "{width:auto;min-width:12rem;min-height:3.125rem;filter:drop-shadow(0 0 8px rgb(0 0 0 / 0.1));}" + ( true ? "" : 0),  true ? "" : 0);
var innerStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__.css)("display:flex;width:100%;background:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_5__/* .accentColor.lineColor */ .z.lineColor, ";box-shadow:0 4px 0 ", (0,main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_5__/* .shadeColor */ .HO)(main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_5__/* .accentColor.lineColor */ .z.lineColor, -20), ";border-radius:0.5rem;color:#fff;transition:background-color 0.3s ease,box-shadow 0.3s ease;&:hover{background-color:", (0,main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_5__/* .shadeColor */ .HO)(main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_5__/* .accentColor.lineColor */ .z.lineColor, 5), ";box-shadow:0 4px 0 ", (0,main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_5__/* .shadeColor */ .HO)(main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_5__/* .accentColor.lineColor */ .z.lineColor, -10), ";}" + ( true ? "" : 0),  true ? "" : 0);
var innerLineStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__.css)(innerStyle, ";background:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_5__/* .accentColor.lineColor */ .z.lineColor, ";box-shadow:0 4px 0 ", (0,main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_5__/* .shadeColor */ .HO)(main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_5__/* .accentColor.lineColor */ .z.lineColor, -20), ";&:hover{background-color:", (0,main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_5__/* .shadeColor */ .HO)(main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_5__/* .accentColor.lineColor */ .z.lineColor, 5), ";box-shadow:0 4px 0 ", (0,main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_5__/* .shadeColor */ .HO)(main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_5__/* .accentColor.lineColor */ .z.lineColor, -10), ";}" + ( true ? "" : 0),  true ? "" : 0);
var innerEmailStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__.css)(innerStyle, ";background:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_5__/* .accentColor.primaryColor */ .z.primaryColor, ";box-shadow:0 4px 0 ", (0,main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_5__/* .shadeColor */ .HO)(main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_5__/* .accentColor.primaryColor */ .z.primaryColor, -20), ";&:hover{background-color:", (0,main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_5__/* .shadeColor */ .HO)(main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_5__/* .accentColor.primaryColor */ .z.primaryColor, 8), ";box-shadow:0 4px 0 ", (0,main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_5__/* .shadeColor */ .HO)(main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_5__/* .accentColor.primaryColor */ .z.primaryColor, -8), ";}" + ( true ? "" : 0),  true ? "" : 0);
var lineFooterTextStyle =  true ? {
  name: "y1f223",
  styles: "margin:auto"
} : 0;
var symbolStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__.css)("position:relative;display:none;align-items:center;justify-content:center;width:44px;box-sizing:border-box;border-right:1px solid rgba(0, 0, 0, 0.1);img{width:26px;}", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_8__/* .moreThanBreakpoint */ .h6)("tablet"), "{display:flex;}" + ( true ? "" : 0),  true ? "" : 0);
var textStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__.css)("font-size:0.875rem;font-weight:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_6__/* .fontWeight.medium */ .Ue.medium, ";line-height:1.4;padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__/* .space.atom1_5x */ .D.atom1_5x, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__/* .space.atom */ .D.atom, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__/* .space.atom1_5x */ .D.atom1_5x, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__/* .space.atom */ .D.atom, ";display:flex;align-items:center;flex:1;letter-spacing:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_6__/* .letterSpacing.text */ .rX.text, ";", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_8__/* .moreThanBreakpoint */ .h6)("tablet"), "{font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_6__/* .fontSize.body */ .JB.body, ";padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__/* .space.atom */ .D.atom, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__/* .space.atom3x */ .D.atom3x, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__/* .space.atom */ .D.atom, " 0;}" + ( true ? "" : 0),  true ? "" : 0);
var textLargeStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__.css)(textStyle, ";font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_6__/* .fontSize.body */ .JB.body, ";" + ( true ? "" : 0),  true ? "" : 0);
var badgeStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__.css)("position:absolute;width:42px;height:24px;text-align:center;line-height:24px;font-size:12px;font-weight:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_6__/* .fontWeight.bold */ .Ue.bold, ";top:-16px;right:-6px;background-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_5__/* .accentColor.secondaryLightColor */ .z.secondaryLightColor, ";border:2px solid #fff;color:#fff;border-radius:16px;", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_8__/* .moreThanBreakpoint */ .h6)("tablet"), "{right:-10px;}" + ( true ? "" : 0),  true ? "" : 0);

/***/ }),

/***/ 91382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W": function() { return /* binding */ LpCruiseSaleList; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
// EXTERNAL MODULE: ./main/javascripts/components/card/Card.tsx
var Card = __webpack_require__(99615);
// EXTERNAL MODULE: ./main/javascripts/components/card/CardImage.tsx + 1 modules
var CardImage = __webpack_require__(4325);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
// EXTERNAL MODULE: ./main/javascripts/styles/base/responsiveStyle.ts
var responsiveStyle = __webpack_require__(88433);
// EXTERNAL MODULE: ./main/javascripts/styles/base/borderStyle.ts
var borderStyle = __webpack_require__(58589);
// EXTERNAL MODULE: ./main/javascripts/components/cruise/CruiseRouteListModalDialog.tsx + 5 modules
var CruiseRouteListModalDialog = __webpack_require__(69599);
// EXTERNAL MODULE: ./main/javascripts/components/button/AButton.tsx
var AButton = __webpack_require__(65644);
// EXTERNAL MODULE: ./main/javascripts/constants/GoogleTagManagerEventTypes.ts
var GoogleTagManagerEventTypes = __webpack_require__(12327);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/cruise/SaleCruisePriceListItem.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }













var SaleCruisePriceListItem = function SaleCruisePriceListItem(props) {
  var salePrice = props.salePrice,
      uniqueId = props.uniqueId,
      departureDate = props.departureDate,
      _props$isEventTrackin = props.isEventTracking,
      isEventTracking = _props$isEventTrackin === void 0 ? false : _props$isEventTrackin;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(["label", "component"]),
      t = _useTranslation.t;

  var params = {
    departure_date: departureDate,
    cabin_code: salePrice.vesselCabinCode
  };
  var paramsString = (0,lib.stringify)(params);
  var showPagePath = "/cruises/".concat(uniqueId, "?").concat(paramsString);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    css: itemStyle,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: contentStyle,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: saleTextStyle,
          children: salePrice.saleText
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          css: cabinNameStyle,
          children: [salePrice.vesselCabinName, " (", salePrice.vesselCabinCode, ")"]
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: priceButtonBlockStyle,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          css: priceBlockStyle,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
            css: priceStyle,
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
              css: priceValueStyle,
              children: salePrice.priceWithoutTaxPerPerson
            }), "/ ", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
              children: t("unit:person", {
                count: 1
              })
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: priceNoteStyle,
            children: t("component:cruise.portFeeExcludedNote")
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: buttonBlockStyle,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AButton/* AButton */.a, _objectSpread(_objectSpread({
            type: "button",
            styleKey: "buttonSmall",
            href: showPagePath,
            target: "_blank",
            rel: "noopener"
          }, isEventTracking ? {
            "data-event-category": GoogleTagManagerEventTypes/* GoogleTagManagerEventTypes.clickCruiseShow */.T.clickCruiseShow
          } : {}), {}, {
            children: t("label:common.showDetail")
          }))
        })]
      })]
    })
  });
};
var itemStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom2x */.D.atom2x, ";&:not(:last-child){border-bottom:1px solid ", colorStyle/* borderColor.primaryLightColor */.tv.primaryLightColor, ";}", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{padding:", spaceStyle/* space.atom1_5x */.D.atom1_5x, " ", spaceStyle/* space.atom2_5x */.D.atom2_5x, ";}" + ( true ? "" : 0),  true ? "" : 0);
var contentStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;gap:", spaceStyle/* space.atom1_5x */.D.atom1_5x, " ", spaceStyle/* space.atom2_5x */.D.atom2_5x, ";" + ( true ? "" : 0),  true ? "" : 0);
var saleTextStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.body */.JB.body, ";line-height:", typographyStyle/* lineHeight.body2 */.Nv.body2, ";color:", colorStyle/* accentColor.primaryColor */.z.primaryColor, ";font-weight:", typographyStyle/* fontWeight.medium */.Ue.medium, ";margin-bottom:", spaceStyle/* space.atom0_5x */.D.atom0_5x, ";" + ( true ? "" : 0),  true ? "" : 0);
var cabinNameStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.body */.JB.body, ";line-height:", typographyStyle/* lineHeight.body2 */.Nv.body2, ";color:", colorStyle/* textColor.primaryDarkColor */.zP.primaryDarkColor, ";" + ( true ? "" : 0),  true ? "" : 0);
var priceButtonBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("display:flex;flex-wrap:wrap;gap:", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom2_5x */.D.atom2_5x, ";align-items:center;justify-content:flex-end;margin-left:auto;" + ( true ? "" : 0),  true ? "" : 0);
var priceBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.body */.JB.body, ";line-height:", typographyStyle/* lineHeight.body2 */.Nv.body2, ";color:", colorStyle/* textColor.primaryDarkColor */.zP.primaryDarkColor, ";" + ( true ? "" : 0),  true ? "" : 0);
var priceStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("display:flex;gap:", spaceStyle/* space.atom0_5x */.D.atom0_5x, ";align-items:flex-end;justify-content:flex-end;font-size:", typographyStyle/* fontSize.body */.JB.body, ";line-height:", typographyStyle/* lineHeight.body2 */.Nv.body2, ";min-width:10.5rem;" + ( true ? "" : 0),  true ? "" : 0);
var priceValueStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.headline */.JB.headline, ";line-height:", typographyStyle/* lineHeight.headline1 */.Nv.headline1, ";font-weight:", typographyStyle/* fontWeight.medium */.Ue.medium, ";font-variant-numeric:tabular-nums;" + ( true ? "" : 0),  true ? "" : 0);
var priceNoteStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.caption */.JB.caption, ";line-height:", typographyStyle/* lineHeight.caption2 */.Nv.caption2, ";color:", colorStyle/* textColor.secondaryDarkColor */.zP.secondaryDarkColor, ";opacity:0.7;text-align:right;" + ( true ? "" : 0),  true ? "" : 0);
var buttonBlockStyle =  true ? {
  name: "1wcbmze",
  styles: "min-width:8rem"
} : 0;
;// CONCATENATED MODULE: ./main/javascripts/components/cruise/SaleCruisePriceList.tsx





var SaleCruisePriceList = function SaleCruisePriceList(props) {
  var salePrices = props.salePrices,
      uniqueId = props.uniqueId,
      departureDate = props.departureDate,
      isEventTracking = props.isEventTracking;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    css: saleListStyle,
    children: salePrices.map(function (salePrice, index) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SaleCruisePriceListItem, {
        salePrice: salePrice,
        uniqueId: uniqueId,
        departureDate: departureDate,
        isEventTracking: isEventTracking
      }, index);
    })
  });
};
var saleListStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("width:100%;border-top:1px solid ", colorStyle/* borderColor.primaryLightColor */.tv.primaryLightColor, ";" + ( true ? "" : 0),  true ? "" : 0);
;// CONCATENATED MODULE: ./main/javascripts/components/cruise/SaleCruiseCard.tsx


function SaleCruiseCard_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SaleCruiseCard_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SaleCruiseCard_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SaleCruiseCard_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function SaleCruiseCard_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


















var SaleCruiseCard = function SaleCruiseCard(props) {
  var _vessel$vesselImages, _vessel$vesselImages$, _saleCruise$departure, _saleCruise$arrivalDa, _salePrices$;

  var saleCruise = props.saleCruise,
      isEventTracking = props.isEventTracking;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(["component", "label", "unit", "button"]),
      t = _useTranslation.t;

  var vessel = saleCruise.vessel;
  var cruiseRoutes = saleCruise.cruiseRoutes || [];
  var salePrices = saleCruise.salePrices || [];

  var _useState = (0,react.useState)(false),
      isCruiseRoutesModalDisplayed = _useState[0],
      setIsCruiseRoutesModalDisplayed = _useState[1];

  var hideCruiseRoutesModal = function hideCruiseRoutesModal(e) {
    e.preventDefault();
    e.stopPropagation();
    setIsCruiseRoutesModalDisplayed(false);
  };

  var displayCruiseRoutesModal = function displayCruiseRoutesModal(e) {
    e.preventDefault();
    e.stopPropagation();
    setIsCruiseRoutesModalDisplayed(true);
  };

  var showPagePath = (0,react.useMemo)(function () {
    if (saleCruise.departureDate) {
      var params = SaleCruiseCard_objectSpread({
        departure_date: saleCruise.departureDate
      }, salePrices[0] && {
        cabin_code: salePrices[0].vesselCabinCode
      });

      var paramsString = (0,lib.stringify)(params);
      return "/cruises/".concat(saleCruise.uniqueId, "?").concat(paramsString);
    }

    return "/cruises/".concat(saleCruise.uniqueId);
  }, [saleCruise.departureDate]);
  var imageUrl = (_vessel$vesselImages = vessel.vesselImages) === null || _vessel$vesselImages === void 0 ? void 0 : (_vessel$vesselImages$ = _vessel$vesselImages[0]) === null || _vessel$vesselImages$ === void 0 ? void 0 : _vessel$vesselImages$.imageUrl;
  var displayDepartureDate = (_saleCruise$departure = saleCruise.departureDate) === null || _saleCruise$departure === void 0 ? void 0 : _saleCruise$departure.replace(/-/g, "/");
  var displayArrivalDate = (_saleCruise$arrivalDa = saleCruise.arrivalDate) === null || _saleCruise$arrivalDa === void 0 ? void 0 : _saleCruise$arrivalDa.replace(/-/g, "/");
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Card */.Z, {
    overflowStyle: "visible",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: innerSaleStyle,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: showPagePath,
        passHref: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", SaleCruiseCard_objectSpread(SaleCruiseCard_objectSpread({
          css: linkStyle,
          target: "_blank"
        }, isEventTracking ? {
          "data-event-category": GoogleTagManagerEventTypes/* GoogleTagManagerEventTypes.clickCruiseShow */.T.clickCruiseShow
        } : {}), {}, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: basicInfoStyle,
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              css: salePriceLabelStyle,
              children: t("component:cruise.salePrice")
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              css: imageBlockStyle,
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: imageStyle,
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardImage/* CardImage */.x, {
                  url: imageUrl
                })
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
              css: infoBlockStyle,
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: titleStyle,
                children: saleCruise.title
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: dataBlockStyle,
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                  children: [t("cruise.vesselName"), ": ", vessel.name]
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                  children: [t("cruise.schedule"), ": ", displayDepartureDate, " ", t("component:common.rangeSeparator"), " ", displayArrivalDate]
                })]
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: dataBlockStyle,
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                  children: [t("cruise.departurePlace"), ": ", saleCruise.departurePortName]
                }), cruiseRoutes.length > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                  children: [t("cruise.arrivalPlace"), ":", " ", cruiseRoutes[cruiseRoutes.length - 1].title]
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                  css: showItineraryButtonBlockStyle,
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: showItineraryButtonStyle,
                    onClick: displayCruiseRoutesModal,
                    children: t("button:cruise.showItinerary")
                  })
                })]
              })]
            })]
          })
        }))
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SaleCruisePriceList, {
        salePrices: salePrices,
        uniqueId: saleCruise.uniqueId,
        departureDate: saleCruise.departureDate,
        isEventTracking: isEventTracking
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CruiseRouteListModalDialog/* CruiseRouteListModalDialog */.Z, {
      displayed: isCruiseRoutesModalDisplayed,
      uniqueId: saleCruise.uniqueId,
      cruiseRoutes: saleCruise.cruiseRoutes,
      departureDate: saleCruise.departureDate,
      cabinCode: (_salePrices$ = salePrices[0]) === null || _salePrices$ === void 0 ? void 0 : _salePrices$.vesselCabinCode,
      closeHandler: hideCruiseRoutesModal,
      isEventTracking: isEventTracking
    })]
  });
};
var innerSaleStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("&::before{content:\"\";position:absolute;top:-1px;left:-1px;width:calc(100% + 2px);height:calc(100% + 2px);border:1px solid ", colorStyle/* accentColor.primaryColor */.z.primaryColor, ";box-sizing:border-box;border-radius:", borderStyle/* borderRadius.normal */.E.normal, ";pointer-events:none;}" + ( true ? "" : 0),  true ? "" : 0);
var basicInfoStyle =  true ? {
  name: "1dkhqzm",
  styles: "display:flex;flex-wrap:wrap;align-items:flex-start;flex:1;cursor:pointer"
} : 0;
var salePriceLabelStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("position:absolute;top:", spaceStyle/* space.atom2x */.D.atom2x, ";left:", spaceStyle/* space.atom2x */.D.atom2x, ";background-color:", colorStyle/* textColor.secondaryAccentColor */.zP.secondaryAccentColor, ";color:#fff;font-size:", typographyStyle/* fontSize.caption */.JB.caption, ";font-weight:", typographyStyle/* fontWeight.medium */.Ue.medium, ";line-height:", typographyStyle/* lineHeight.caption2 */.Nv.caption2, ";letter-spacing:", typographyStyle/* letterSpacing.text */.rX.text, ";padding:0.125rem ", spaceStyle/* space.atom */.D.atom, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{top:", spaceStyle/* space.atom2_5x */.D.atom2_5x, ";left:", spaceStyle/* space.atom2_5x */.D.atom2_5x, ";}" + ( true ? "" : 0),  true ? "" : 0);
var imageBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("width:100%;box-sizing:border-box;padding:", spaceStyle/* space.atom2x */.D.atom2x, " ", spaceStyle/* space.atom2x */.D.atom2x, " ", spaceStyle/* space.atom */.D.atom, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{height:auto;width:38%;padding:", spaceStyle/* space.atom2_5x */.D.atom2_5x, ";padding-right:0;}" + ( true ? "" : 0),  true ? "" : 0);
var imageStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("aspect-ratio:2/1;overflow:hidden;border-radius:", borderStyle/* borderRadius.normal */.E.normal, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{aspect-ratio:3/2;}" + ( true ? "" : 0),  true ? "" : 0);
var infoBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("width:100%;box-sizing:border-box;padding:", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom */.D.atom, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{width:62%;padding:", spaceStyle/* space.atom2x */.D.atom2x, " ", spaceStyle/* space.atom1_5x */.D.atom1_5x, ";}" + ( true ? "" : 0),  true ? "" : 0);
var titleStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.headline */.JB.headline, ";line-height:", typographyStyle/* lineHeight.headline1 */.Nv.headline1, ";font-weight:", typographyStyle/* fontWeight.medium */.Ue.medium, ";color:", colorStyle/* textColor.primaryDarkColor */.zP.primaryDarkColor, ";padding:", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom */.D.atom, ";" + ( true ? "" : 0),  true ? "" : 0);
var dataBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom */.D.atom, ";font-size:", typographyStyle/* fontSize.body */.JB.body, ";line-height:", typographyStyle/* lineHeight.body2 */.Nv.body2, ";color:", colorStyle/* textColor.secondaryDarkColor */.zP.secondaryDarkColor, ";" + ( true ? "" : 0),  true ? "" : 0);
var showItineraryButtonBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("display:flex;justify-content:flex-start;padding:", spaceStyle/* space.atom1_5x */.D.atom1_5x, " 0 0;" + ( true ? "" : 0),  true ? "" : 0);
var showItineraryButtonStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.body */.JB.body, ";line-height:", typographyStyle/* lineHeight.body2 */.Nv.body2, ";color:", colorStyle/* accentColor.primaryColor */.z.primaryColor, ";cursor:pointer;text-decoration:underline;text-underline-offset:0.5rem;transition:opacity 0.3s ease;&:hover{opacity:0.8;}" + ( true ? "" : 0),  true ? "" : 0);
var linkStyle =  true ? {
  name: "g65o95",
  styles: "text-decoration:none"
} : 0;
;// CONCATENATED MODULE: ./main/javascripts/features/lp/cruise/components/LpCruiseSaleList.tsx




var LpCruiseSaleList = function LpCruiseSaleList(props) {
  var saleCruises = props.saleCruises;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: saleCruises.map(function (cruise, index) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SaleCruiseCard, {
        saleCruise: cruise,
        isEventTracking: true
      }, index);
    })
  });
};

/***/ }),

/***/ 17844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ useScroll; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useScroll = function useScroll(onScroll) {
  var animationFrameRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);

  var handleScroll = function handleScroll() {
    if (animationFrameRef.current) {
      cancelAnimationFrame(animationFrameRef.current);
    }

    animationFrameRef.current = requestAnimationFrame(function () {
      if (onScroll) {
        onScroll(window.scrollY);
      }
    });
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    window.addEventListener("scroll", handleScroll);
    return function () {
      window.removeEventListener("scroll", handleScroll);

      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
    };
  }, []);
};

/***/ })

}]);